import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=18e7566c&"
import script from "./Extract.vue?vue&type=script&lang=js&"
export * from "./Extract.vue?vue&type=script&lang=js&"
import style0 from "./Extract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports